import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@app/material.module';

@NgModule({
  imports: [MaterialModule, CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  declarations: [
    //Pipes
    //Directives
  ],
  exports: [
    //Components
  ],
  providers: [],
})
export class SCLocalModule {}
